import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

export default function About() {
  return (
    <Layout>
      <Seo
        title="About SCMBrain | Supply Chain Intelligence for Practitioners"
        description="SCMBrain delivers analyst-grade supply chain frameworks, tools, and the AI-powered Intelligent SCM Scan — built by practitioners, for practitioners."
        path="/about"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">About SCMBrain</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B] leading-tight">
          Built by practitioners, for practitioners.
        </h1>

        <div className="mt-8 space-y-5 text-[#3E577A] leading-relaxed text-[17px]">
          <p>
            SCMBrain exists because most supply chain content is written for consultants, not the people
            doing the work. We're closing that gap with analyst-grade frameworks, honest analysis, and
            practical tools you can put to use the same day you find them.
          </p>
          <p>
            Our flagship product, the Intelligent SCM Scan, gives planning teams a fast, structured read
            on where they stand across Demand Planning, Inventory Planning, Supply Planning, and S&OP — and
            an AI-generated diagnosis of where to focus first.
          </p>
          <p>
            We cover the full planning landscape — Plan, Source, Make, and Deliver — with a strong point of
            view on where AI and GenAI genuinely move the needle, and where they're just noise.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-5">
          {[
            { k: "4", v: "Planning functions assessed" },
            { k: "48+", v: "Diagnostic questions" },
            { k: "15 min", v: "To your free maturity score" },
          ].map((s) => (
            <div key={s.v} className="bg-[#F4F4F4] border border-[#E5E7EB] rounded-sm p-6">
              <div className="font-heading text-3xl font-extrabold text-[#1A6B5A]">{s.k}</div>
              <div className="text-sm text-[#3E577A] mt-1">{s.v}</div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <h2 className="font-heading text-xl font-bold text-[#1B3A6B] mb-2">Contact</h2>
          <p className="text-[#3E577A]">General & privacy enquiries: <a className="text-[#1A6B5A] underline" href="mailto:scmbrainhq@gmail.com">scmbrainhq@gmail.com</a></p>
        </div>

        <Link to="/scan" className="inline-flex items-center gap-2 mt-10 bg-[#1A6B5A] text-white rounded-sm px-6 py-3.5 font-semibold">
          Start Free Assessment <ArrowRight className="h-4 w-4" />
        </Link>
      </section>
    </Layout>
  );
}
